/**
 * @enum Perm
 */
import {EntryDesc} from 'generated/JavaTOmodifications'
import {PermissionTO} from 'generated/JavaTO'

export const Perm = {
	rd: 'rd',
	crt: 'crt',
	upd: 'upd',
	del: 'del',
	gen: 'gen',
	abl: 'abl',
	storno: 'storno',
} as const

type PermName = keyof typeof Perm

const scopedPermName = (pn: PermName, selfadmin: boolean) => (selfadmin ? pn + "_s" : pn) as keyof PermissionTO

export const TypePerm = {
	check(ed: EntryDesc | { attributes: EntryDesc } | PermissionTO | undefined | null, perm: PermName, selfadmin = true) {
		if (!perm || !ed) return false
		ed = (ed as { attributes: EntryDesc }).attributes || ed
		const typePerm = (ed && ed.perm || ed) as PermissionTO
		const ret = perm && typePerm[scopedPermName(perm, selfadmin)]
		return typeof ret === 'boolean' ? ret : false
	},

	// can be used if multiple permissions have to get checked for the same entry
	getAll(ed: EntryDesc | undefined | null, selfadmin = true) {
		return {
			rd: TypePerm.check(ed, Perm.rd, selfadmin),
			crt: TypePerm.check(ed, Perm.crt, selfadmin),
			upd: TypePerm.check(ed, Perm.upd, selfadmin),
			del: TypePerm.check(ed, Perm.del, selfadmin),
			gen: TypePerm.check(ed, Perm.gen, selfadmin),
			abl: TypePerm.check(ed, Perm.abl, selfadmin),
			storno: TypePerm.check(ed, Perm.storno, selfadmin),
		}
	},
}